// extracted by mini-css-extract-plugin
export var divider = "_3f-0";
export var dividerText = "_3f-2";
export var dividerVertical = "_3f-1";